var exports = {
  "w": "xcc377c0b--208808--loader",
  "x": "xcc377c0b--208808--skeleton-animation",
};

module.exports = exports;
